module.exports = __webpack_public_path__ + "static/media/back.1b66e268.svg";